import Vue from 'vue';

import OAuth from '@/lib/oauth';

import { CLIENT_IDS as clientIds, REDIRECT_URI as redirectUri } from '@/config/xsolla';
import serviceConfiguration from '@/config/oauth';

Vue.use(OAuth);

export default new OAuth({
  clientIds,
  redirectUri: redirectUri as string,
  serviceConfiguration,
});
